export default __webpack_public_path__ + "static/media/tornado.4f634acd.svg";